<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner">
      <v-card class="auth-card">
        <!-- logo -->
        <v-card-title class="d-flex align-center justify-center py-7">
          <router-link to="/" class="d-flex align-center">
            <v-img
              :src="require('@/assets/images/logos/main-logo.png')"
              max-height="90px"
              max-width="90px"
              alt="logo"
              contain
              class="me-3"
            ></v-img>

            <h2 class="text-2xl font-weight-semibold">GOODLIFE GROUP OF COMPANIES</h2>
          </router-link>
        </v-card-title>

        <!-- title -->
        <v-card-text>
          <p class="mb-2">Please sign-in to your account and start the transaction</p>
        </v-card-text>

        <!-- login form -->
        <v-card-text>
          <div v-if="!loading">
            <v-form ref="form">
              <v-text-field
                v-model="id_no"
                outlined
                label="ID #"
                placeholder="CHAP-0-0000"
                hide-details
                class="mb-3"
                :rules="rules.non_empty_field_rule"
                @keyup.enter="login"
              ></v-text-field>

              <v-text-field
                v-model="password"
                outlined
                :type="isPasswordVisible ? 'text' : 'password'"
                label="Password"
                placeholder="············"
                :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
                hide-details
                @click:append="isPasswordVisible = !isPasswordVisible"
                :rules="rules.non_empty_field_rule"
                @keyup.enter="login"
              ></v-text-field>

              <div class="d-flex align-center justify-space-between flex-wrap">
                <!--                <v-checkbox disabled label="Remember Me" hide-details-->
                <!--                            class="me-3 mt-1"></v-checkbox>-->
                <a href="javascript:void(0)" class="mt-1" @click="forget_password"> Forgot
                  Password? </a>
              </div>
              <v-alert block type="error" dense v-if="this.require">
                {{ require_msg }}
              </v-alert>
              <v-btn block color="primary" class="mt-6" @click="login"> Login</v-btn>
            </v-form>
          </div>
          <div v-else class="text-center">
            <h2 class="font-weight-light">Validating.....</h2>
            <v-progress-circular :size="75" :width="5" color="primary"
                                 indeterminate></v-progress-circular>
          </div>
        </v-card-text>

        <!-- divider -->
        <v-card-text class="d-flex align-center mt-2">
          <v-divider></v-divider>
          <span class="mx-5">or</span>
          <v-divider></v-divider>
        </v-card-text>

        <!-- create new account  -->
        <v-card-text class="d-flex align-center justify-center flex-wrap mt-2">
          <span class="me-2"> Contact us via FB & Gmail</span>
        </v-card-text>

        <!-- social links -->
        <v-card-actions class="d-flex justify-center">
          <v-btn v-for="link in socialLink" :key="link.icon" icon class="ms-1" :href="link.url">
            <v-icon :color="$vuetify.theme.dark ? link.colorInDark : link.color">
              {{ link.icon }}
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>

    <!-- background triangle shape  -->
    <img
      class="auth-mask-bg"
      height="173"
      :src="require(`@/assets/images/misc/mask-${$vuetify.theme.dark ? 'dark' : 'light'}.png`)"
    />

    <!-- tree -->
    <!--    <v-img class="auth-tree" width="247" height="185" src="@/assets/images/misc/tree.png"></v-img>-->

    <!-- tree  -->
    <!--    <v-img class="auth-tree-3" width="377" height="289"-->
    <!--           src="@/assets/images/misc/tree-3.png"></v-img>-->

    <v-dialog v-model="is_change_password" persistent max-width="50%">
      <ChangePassword :id_no_change="id_no"></ChangePassword>
    </v-dialog>
  </div>
</template>

<script>
import {mdiFacebook, mdiGoogle, mdiEyeOutline, mdiEyeOffOutline} from '@mdi/js'
import {mapActions, mapGetters} from 'vuex'
import fpPromise from '@fingerprintjs/fingerprintjs'
import ChangePassword from "@/views/dashboard/ChangePassword";

export default {

  data() {
    return {
      isPasswordVisible: false,
      is_change_password: false,
      loading: false,
      require: false,

      id_no: '',
      password: '',
      require_msg: '',
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
      socialLink: [
        {
          icon: mdiFacebook,
          color: '#4267b2',
          colorInDark: '#4267b2',
          url: 'https://www.facebook.com/goodlife.itd/',
        },
        {
          icon: mdiGoogle,
          color: '#db4437',
          colorInDark: '#db4437',
          url: 'https://mail.google.com/mail/u/0/#inbox',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
  },
  components: {
    ChangePassword,
  },
  methods: {
    ...mapActions('authentication', ['login_credentials']),
    ...mapActions('users', ['checker_otp_login', 'create_otp_login', 'create_otp_forget_password']),
    useNavigatorInfo() {
      const userAgent = navigator.userAgent.toLowerCase()
      const Android = userAgent.indexOf('android') > -1
      let os_main = 'Windows'

      if (navigator.appVersion.indexOf("Win") != -1) {
        os_main = 'Windows'
      }

      if (navigator.appVersion.indexOf("Mac") != -1) {
        os_main = 'Mac'
      }

      if (navigator.appVersion.indexOf("X11") != -1) {
        os_main = 'UNIX'
      }

      if (navigator.appVersion.indexOf("Linux") != -1) {
        os_main = 'Linux'
      }

      if (Android) {
        os_main = 'Android'
      }

      return {
        os_main: os_main
      }
    },
    verify_login(data) {
      this.login_credentials(data)
        .then(response => {
          // console.log(response.data)
          if (
            response.data === 'The provided USER INFO are incorrect.' ||
            response.data === 'The provided EMPLOYEE INFO are incorrect.' ||
            response.data === 'The USER is already Login' ||
            response.data === 'error'
          ) {
            this.require = true
            this.require_msg = response.data
          } else {
            this.$router.push({path: '/dashboard'})
            // location.reload()
          }
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    async login() {
      this.loading = true
      this.require = false
      if (this.$refs.form.validate()) {
        fpPromise.load()
          .then(fp => fp.get())
          .then(result => {
            // This is the visitor identifier:
            const navi = this.useNavigatorInfo()
            const fpDetails = {
              deviceMemory: result.components.deviceMemory.value,
              cpuThreads: result.components.hardwareConcurrency.value,
              os: navi.os_main,
              gpu: result.components.webGlBasics.value.rendererUnmasked,
              username: '',
            }
            const data = new FormData()
            data.append('id_no', this.id_no)
            data.append('password', this.password)
            data.append('website', 'GOODLIFE PORTAL')
            data.append('device_os', fpDetails.os);
            this.verify_login(data)
            // let excepted = (this.id_no === 'HO-2-2018' || this.id_no === 'Ho-2-2018' || this.id_no === 'ho-2-2018' || this.id_no === 'hO-2-2018');
            // if (excepted) {
            //   this.verify_login(data)
            // } else {
            //   this.create_otp_login(data)
            //     .then(response => {
            //       if (response.status === 201) {
            //         this.require = true
            //         this.require_msg = response.data
            //         this.loading = false
            //       } else {
            //         let otp_input = prompt("Please enter OTP");
            //         if (otp_input == null || otp_input === "") {
            //           this.require = true
            //           this.require_msg = 'User cancelled the prompt.'
            //           this.loading = false
            //         } else {
            //           data.append('otp', otp_input);
            //           this.checker_otp_login(data)
            //             .then(response => {
            //               if (response.status === 201) {
            //                 this.require = true
            //                 this.require_msg = response.data
            //                 this.loading = false
            //               } else {
            //                 this.verify_login(data)
            //               }
            //             })
            //             .catch(error => {
            //               this.loading = false
            //               console.log(error)
            //             })
            //         }
            //       }
            //     })
            //     .catch(error => {
            //       this.loading = false
            //       console.log(error)
            //     })
            // }
          })
          .catch(() => {
            this.loading = false
            alert('Error upon validation!')
          })
      } else {
        this.loading = false
      }
    },
    async forget_password() {
      let id_no_input = prompt("Please enter ID#");
      if (id_no_input == null || id_no_input === "") {
        this.require = true
        this.require_msg = 'User cancelled the prompt.'
        this.loading = false
      } else {
        this.id_no = id_no_input
        fpPromise.load()
          .then(fp => fp.get())
          .then(result => {
            // This is the visitor identifier:
            const navi = this.useNavigatorInfo()
            const fpDetails = {
              deviceMemory: result.components.deviceMemory.value,
              cpuThreads: result.components.hardwareConcurrency.value,
              os: navi.os_main,
              gpu: result.components.webGlBasics.value.rendererUnmasked,
              username: '',
            }
            const data = new FormData()
            data.append('id_no', this.id_no)
            data.append('website', 'GOODLIFE PORTAL')
            data.append('device_os', fpDetails.os);
            this.create_otp_forget_password(data)
              .then(response => {
                if (response.status === 201) {
                  this.require = true
                  this.require_msg = response.data
                  this.loading = false
                } else {
                  let otp_input = prompt("Please enter OTP");
                  if (otp_input == null || otp_input === "") {
                    this.require = true
                    this.require_msg = 'User cancelled the prompt.'
                    this.loading = false
                  } else {
                    data.append('otp', otp_input);
                    this.checker_otp_login(data)
                      .then(response => {
                        if (response.status === 201) {
                          this.require = true
                          this.require_msg = response.data
                          this.loading = false
                        } else {
                          this.is_change_password = true
                        }
                      })
                      .catch(error => {
                        this.loading = false
                        console.log(error)
                      })
                  }
                }
              })
              .catch(error => {
                this.loading = false
                console.log(error)
              })
          })
          .catch(() => {
            this.loading = false
            alert('Error upon validation!')
          })
      }
    },
  },
}
</script>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/pages/auth.scss';
</style>
